const colors = {
  dark: "#000000",
  white: "#FFFFFF",
  yellow: "#F9FF00",
  blue: "#4842F5",
  red: "#FF5C63",
  green: "#74E852",
};

export default colors;
